import { Form, Input, InputNumber, Select } from 'antd';
import { WrappedFormUtils } from 'antd/lib/form/Form';
import React from 'react';
import { FormContext } from './CreditsRow';

const FormItem = Form.Item;
const TextArea = Input.TextArea;

interface IObjectData {
    [key: string]: string;
}

interface ILocalProps {
    inputtype?: string;
    editing?: boolean;
    dataIndex: string;
    title: string;
    record: IObjectData;
}

class CreditsCell extends React.Component<ILocalProps> {
    public getInput = () => {
        if (this.props.inputtype === 'number') {
            return <InputNumber />;
        } else if (this.props.inputtype === 'select') {
            if (this.props.dataIndex === 'type') {
                return (
                        <Select>
                            <Select.Option value={0}>Standard</Select.Option>
                            <Select.Option value={1}>SharpSpring Fee</Select.Option>
                        </Select>
                    )
            }
        }

        return <TextArea autosize={{ minRows: 2, maxRows: 4}} />;
    };

    public getRules = () => {
        const rules: any = {};
        if (this.props.dataIndex === 'spread'
            || this.props.dataIndex === 'creditAmount'
            || this.props.dataIndex === 'creditBalance'
        ) {
            rules.type = 'number';
        }
        if (this.props.dataIndex === 'spread'
            || this.props.dataIndex === 'creditBalance') {
            rules.min = 0;
        }

        if (this.props.dataIndex === 'creditAmount') {
            rules.min = 1;
        }

        if (this.props.dataIndex === 'note'
            || this.props.dataIndex === 'childCompanyProfileID') {
            rules.required = false;
        }
        return rules;
    };

    public getInitialValue = (value: string) => {
        if (this.props.dataIndex === 'creditAmount' || this.props.dataIndex === 'creditBalance') {
            return parseFloat(value.substr(1).trim());
        }
        return value;
    };

    public render() {
        const {
            editing,
            dataIndex,
            title,
            record,
            ...restProps
        } = this.props;
        const rules: any = this.getRules();
        return (
            <FormContext.Consumer>
                {(form: WrappedFormUtils | null) => {
                    if (!form) {
                        return;
                    }
                    const { getFieldDecorator } = form;
                    return (
                        <td {...restProps}>
                            {editing ? (
                                <FormItem style={{ margin: 0 }}>
                                    {getFieldDecorator(dataIndex, {
                                        initialValue: this.getInitialValue(record[dataIndex]),
                                        rules: [{
                                            message: `Please enter valid ${title}!`,
                                            required: true,
                                            ...rules,
                                        }],
                                    })(this.getInput())}
                                </FormItem>
                            ) : restProps.children}
                        </td>
                    );
                }}
            </FormContext.Consumer>
        );
    }
}

export default CreditsCell;
